document.addEventListener('DOMContentLoaded', () => {

    const targets = document.querySelectorAll('img,#wyng-section');

    const wyngSection = document.getElementById('wyng-section');

    const replaceImgSrc = img => {
      const src = img.getAttribute('data-lazy-src');
      const srcset = img.getAttribute('data-lazy-srcset');

      if (!img.getAttribute('src') && src) {
        img.setAttribute('src', src);
      }
      if (!img.getAttribute('src') && srcset) {
        img.setAttribute('srcset', srcset);
      }
    }

    const insertWyng = () => {
      const wyngTemplate = document.getElementById('wyng-template');
      if (wyngTemplate) {
        const wyngHtml = wyngTemplate.content.cloneNode(true);
        wyngSection.appendChild(wyngHtml);
      }
    }

    const lazyLoad = target => {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.target === wyngSection) {
            insertWyng();
            observer.disconnect();
          } else if (entry.isIntersecting) {
            replaceImgSrc(entry.target);
            observer.disconnect();
          }
        });
      });

      io.observe(target);
    };

    const fallback = target => {
      if (target === wyngSection ) {
        insertWyng();
      } else {
        replaceImgSrc(target);
      }
    };

    if (Object.prototype.hasOwnProperty.call(window.IntersectionObserverEntry, 'isIntersecting')) {
      targets.forEach(lazyLoad);
    } else {
      targets.forEach(fallback);
    }

});
